import React from 'react';
import { useSelector } from 'react-redux';
import { Card, CardHeader, CardBody } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import CountUp from 'react-countup';
import Skeleton from 'react-loading-skeleton';
import Loader from '../../../components/common/Loader';

function InAppConsumptionCard({ mostUsedServiceName, mostUsedServiceCount, mostViewServiceName, mostViewServiceCount }) {
    const inAppLoading = useSelector(state => state.salesPrediction.loading);
    const hasData = mostUsedServiceName || mostViewServiceName;
    return (
        <Card
            className="d-flex align-items-center"
            style={{
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                borderRadius: "10px",
            }}
        >
            <CardHeader className="align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1 ">
                    <b>In-App Consumption</b>
                </h4>
            </CardHeader>

            {inAppLoading ?
                (<CardBody
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "212px"
                    }}
                    className="w-100">

                    <Loader />
                </CardBody>
                ) : (

                    hasData ? (
                    <CardBody className="position-relative w-100">
                        <div className="d-flex align-items-center">
                            <div className="avatar-s flex-shrink-0">
                                <span
                                    className={`bg-briefcase-subtle fs-2`}
                                    style={{ height: "20px", width: "20px" }}
                                >
                                    <FeatherIcon
                                        icon={"eye"}
                                        className={`text-secondary`}
                                    />
                                </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden ms-3">
                                <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                                    Most Viewed Service / Count
                                </p>

                                <div className="d-flex align-items-center mb-3">
                                    <h6 className="fs-6 flex-grow-1 mb-0">
                                        <span
                                            className="counter-value me-1"
                                            data-target="825"
                                        >
                                            {mostViewServiceName ? mostViewServiceName : <Skeleton />}

                                        </span>
                                    </h6>

                                    <span
                                        className="counter-value fs-13 badge bg-secondary-subtle text-secondary">
                                        <CountUp
                                            start={0}
                                            suffix={""}
                                            separator={""}
                                            end={
                                                mostViewServiceCount ? mostViewServiceCount : <Skeleton />

                                            }
                                            duration={4}
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="d-flex align-items-center">
                            <div className="avatar-s flex-shrink-0">
                                <span
                                    className={`bg-briefcase-subtle fs-2`}
                                    style={{ height: "20px", width: "20px" }}
                                >
                                    <FeatherIcon
                                        icon={"shopping-cart"}
                                        className={`text-secondary`}
                                    />
                                </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden ms-3">
                                <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                                    Most Used Service / Count
                                </p>

                                <div className="d-flex align-items-center mb-3">
                                    <h6 className="fs-6 flex-grow-1 mb-0">
                                        <span
                                            className="counter-value me-1"
                                            data-target="825"
                                        >
                                            {mostUsedServiceName ? mostUsedServiceName : <Skeleton />}

                                        </span>
                                    </h6>

                                    <span
                                        className="counter-value fs-13 badge bg-secondary-subtle text-secondary">
                                        <CountUp
                                            start={0}
                                            suffix={""}
                                            separator={""}
                                            end={
                                                mostUsedServiceCount ? mostUsedServiceCount : <Skeleton />
                                            }
                                            duration={4}
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                    ): (
                        <CardBody className="w-100">
                        <div className="table-responsive table-card h-100"
                            style={{
                                minHeight: "215px",
                                maxHeight: "215px",
                                padding: "15px",
                            }}
                        >
                            <table className="table table-centered align-middle mb-0">
                                <tbody>
                                    <tr>
                                        <td colSpan="3" className="text-center">
                                            No Data Available
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                    )
                )
            }
        </Card>
    );
}

export default InAppConsumptionCard;
